import { render, staticRenderFns } from "./ColoresEstadoDispositivo.vue?vue&type=template&id=2fedd96c&scoped=true"
import script from "./ColoresEstadoDispositivo.vue?vue&type=script&setup=true&lang=js"
export * from "./ColoresEstadoDispositivo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ColoresEstadoDispositivo.vue?vue&type=style&index=0&id=2fedd96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedd96c",
  null
  
)

export default component.exports